import { UserSettingsPages, WorkspaceSettingsPages } from "./constants";

interface ResolveActiveSettingsPathParams {
    pathSegments: string[];
    validPaths: string[];
}

export function resolveActiveSettingsPath({
    pathSegments,
    validPaths,
}: ResolveActiveSettingsPathParams): string[] {
    const isOnExpiredBillingTransfer =
        pathSegments[0] === WorkspaceSettingsPages.BILLING_TRANSFER &&
        !validPaths.includes(WorkspaceSettingsPages.BILLING_TRANSFER);

    if (!isOnExpiredBillingTransfer) {
        return pathSegments;
    }

    return validPaths.includes(WorkspaceSettingsPages.BILLING)
        ? [WorkspaceSettingsPages.BILLING]
        : [UserSettingsPages.GENERAL];
}
